import { render, staticRenderFns } from "./个人中心.vue?vue&type=template&id=2ce07a7a&scoped=true"
import script from "./个人中心.vue?vue&type=script&lang=js"
export * from "./个人中心.vue?vue&type=script&lang=js"
import style0 from "./个人中心.vue?vue&type=style&index=0&id=2ce07a7a&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2ce07a7a",
  null
  
)

export default component.exports